import { render, staticRenderFns } from "./TestimonialTab.vue?vue&type=template&id=1099b5eb&"
import script from "./TestimonialTab.vue?vue&type=script&lang=js&"
export * from "./TestimonialTab.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialTab.vue?vue&type=style&index=0&id=1099b5eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports